export default __webpack_public_path__ + "static/media/Snd_1_Starts.00127697.mp3";